import React, { useLayoutEffect, useRef, useState, createContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
/*components*/
import Account from "pages/Auth/components/Account";
import Offices from "pages/Ofiices";
import AddOffice from "pages/Ofiices/AddOffice";
import Staff from "pages/Staff";
import StaffDetail from "pages/Staff/StaffDetail";
import AddStaff from "pages/Staff/AddStaff";
import App from "./App";
import axios from "axios";
import { createBrowserHistory } from "history";
import PrivateRoutes from "./privateRoute";
import Helper from "utils/helper";
import { finalizeAppLogoutRedirect } from "utils/appLogout";
import { refreshMsalIdTokenCoalesced } from "services/msalTokenRefresh";
import MobileApp from "components/MobileApp";
import EditProfile from "pages/Auth/components/EditProfile";
import Profile from "pages/Auth/components/Profile";
import DemoRequest from "pages/SuperAdmin/DemoRequest";
import BroadcastMessages from "pages/SuperAdmin/BroadcastMessages";
import AddBroadcastMessage from "pages/SuperAdmin/BroadcastMessages/AddMessage";
import BroadcastMessageDetail from "pages/SuperAdmin/BroadcastMessages/Detail";
import ManageTestimonial from "pages/SuperAdmin/Testimonianls/ManageTestimonial";
import AddTestimonial from "pages/SuperAdmin/Testimonianls/AddTestimonial";
import Privacy from "pages/PrivacyPolicy";
import PrivacyPolicyPatient from "pages/PrivacyPolicyPatient";
import StaffRoles from "pages/StaffRoles";
import ManageContent from "pages/SuperAdmin/ManageContent";
import Terms from "pages/TermsCondtion";
import TermsCondtionPatient from "pages/TermsCondtionPatient";
import ChangePassword from "pages/Change-Password";
import NotFound from "components/notFound";
import CardDetails from "pages/Subscription/Card";
import AccountManageSubscription from "pages/Subscription/ManageSubscription";
import AddSubscription from "pages/Subscription/AddSubscription";
import SubscriptionMangement from "pages/Subscription/Mangement";
import PlanDetail from "pages/Subscription/PlanDetail";
import EnterPrisePlans from "pages/Subscription/EnterPrisePlans";
import AddEnterPrisePlan from "pages/Subscription/AddEnterprisePlan";
import EnterPriseOwners from "pages/Subscription/EnterpriseOwners";
import AddOwner from "pages/Subscription/AddOwner";
import EditPlans from "pages/Subscription/EditPlan";
import SubscriptionPlans from "pages/Subscription/SubPlans";
import SelectOffice from "pages/Ofiices/SelectOffices";
import MangeHolidays from "pages/Holidays/MangeHolidays";
import ManageCards from "pages/Subscription/ManageCards";
import ChangeCard from "pages/Subscription/ChangeCard";
import StaffList from "pages/SuperAdmin/Account-owner/StaffList";
import AccountOwnerRoutes from "pages/SuperAdmin/Account-owner/AccountOwnerRoutes";
import PersonnelRoutes from "pages/SuperAdmin/Personnel/PersonnelRoutes";
import AppVersionList from "pages/SuperAdmin/AppVersion/List";
import constants from "./../constants";
import AppVersionForm from "pages/SuperAdmin/AppVersion/Form";
import SpecialtyList from "pages/SuperAdmin/Specialty/List";
import SpecialtyForm from "pages/SuperAdmin/Specialty/Form";
import Doctors from "../patient-scheduling/pages/Doctors";
import SearchDoctorBySpecialty from "../patient-scheduling/pages/SearchDoctorBySpecialty";
import SetLocation from "../patient-scheduling/pages/SetLocation";
import DoctorOffices from "../patient-scheduling/pages/Offices";
import Timesheet from "staff/pages/Timesheet";
import TimesheetView from "staff/pages/TimesheetView";
import TimesheetViewDetails from "staff/pages/TimesheetViewDetails";
import StaffOffices from "staff/pages/Offices";
import StaffOfficeOptions from "staff/pages/StaffOfficeOptions";
import AccountAdmin from "staff/pages/AccountAdmin";
import OfficeContracts from "staff/pages/OfficeContracts";
import ViewContract from "staff/pages/ViewContract";

import OfficeOptions from "accountOwner/pages/OfficeOptions";
import Preferences from "accountOwner/pages/Preferences";
import DefineGeoFence from "accountOwner/pages/DefineGeoFence";
import PatientList from "pages/SuperAdmin/PatientList";
import Reviews from "pages/SuperAdmin/Reviews";
import PatientReviews from "pages/SuperAdmin/PatientReviews";
import StaffContracts from "accountOwner/pages/Forms/Contracts/staffContracts";
import NewEmploymentContract from "accountOwner/pages/NewEmploymentContract";
import DoctorDetail from "patient-scheduling/pages/DoctorDetail";
import DoctorReviews from "pages/SuperAdmin/DoctorReviews";
import DoctorReviewsByOffice from "patient-scheduling/pages/Reviews";
import OwnerViewContract from "accountOwner/pages/OwnerViewContract";
import HourlyRateHistory from "pages/Staff/HourlyRateHistory";
import AddEvent from "accountOwner/pages/AddEvent";
import EventDetails from "accountOwner/pages/EventDetails";
import EventRequestDetails from "accountOwner/pages/EventRequestDetails";
import Scheduler from "accountOwner/pages/Scheduler";
import RequestAnAppointment from "patient-scheduling/pages/RequestAppointment";
import AddBusySlots from "BusySlots/AddBusySlots";
import BusySlotsDetail from "BusySlots/BusySlotsDetail";
import Notification from "notification/index";
import EventWorkingDetails from "accountOwner/pages/EventWorkingDetails";
import EditEvent from "accountOwner/pages/EditEvent";
import ManageCatalogue from "VendorManagement/pages/ManageCatalogue";
import AddNewItem from "VendorManagement/pages/ManageCatalogue/AddNewItem";
import CatalogueDetail from "VendorManagement/pages/ManageCatalogue/CatalogueDetail";
import TopUp from "VendorManagement/pages/TopUp";
import EditBusySlot from "BusySlots/EditBusySlot";
import SupportHelpdesk from "VendorManagement/pages/SupportHelpdesk";
import AddNewTicket from "VendorManagement/pages/SupportHelpdesk/AddNewTicket";
import VendorTicketDetail from "VendorManagement/pages/SupportHelpdesk/TicketDetail";
import CustomerDetail from "VendorManagement/pages/ManageCustomers/CustomerDetail";
import ManageCustomers from "VendorManagement/pages/ManageCustomers";
import Dashboard from "VendorManagement/pages/Dashboard";
import VendorProfile from "VendorManagement/pages/Dashboard/VendorProfile";
import ManageOrders from "VendorManagement/pages/ManageOrders";
import OrderDetail from "VendorManagement/pages/ManageOrders/OrderDetail";
import HelpPage from "Help";
import FeedbackPage from "Feedback";
import EventDetailsOnly from "../accountOwner/pages/EventDetailsOnly";
import OnlineHelp from "Help/OnlineHelp/OnlineHelp";
import Faq from "../Help/FAQ";
import InviteCustomers from "VendorManagement/pages/ManageCustomers/InviteCustomers";
import PromoCodes from "VendorManagement/pages/PromoCodes";
import AddNewPromoCode from "VendorManagement/pages/PromoCodes/AddNewPromoCode";
import ManageSaleRep from "VendorManagement/pages/ManageSaleRep";
import InviteNewSalesRep from "VendorManagement/pages/ManageSaleRep/InviteNewSalesRep";
import EditSalesRep from "VendorManagement/pages/ManageSaleRep/EditSalesRep";
import SalesRepDetail from "VendorManagement/pages/ManageSaleRep/SalesRepDetail";
import WaitingListForm from "patient-scheduling/pages/WaitingListForm";
import AppointmentRequests from "pages/SuperAdmin/AppointmentRequests";
import AppointmentRequestDetail from "pages/SuperAdmin/AppointmentRequestDetail";
import TeamConversation from "Messenger/pages/TeamConversation";
import Feedback from "../pages/SuperAdmin/FeedBack";
import FeedBackView from "../pages/SuperAdmin/FeedBack/FeedBackView";
import Promotion from "VendorManagement/pages/Promotion";
import PromotionDetail from "VendorManagement/pages/Promotion/PromotionDetail";
import AddNewPromotion from "VendorManagement/pages/Promotion/AddNewPromotion";
import ManageInvoices from "VendorManagement/pages/ManageInvoices";
import DownloadIcs from "pages/DownloadIcs";
import QuestionnaireForm from "patient-scheduling/pages/QuestionnaireForm";
import SupportHelp from "pages/SuperAdmin/Support-help";
import TicketDetail from "pages/SuperAdmin/Support-help/TicketDetail";
import EditSubscription from "pages/SuperAdmin/Account-owner/SubscriptionAndInvoices/EditSubscription";
import ManageCategories from "pages/SuperAdmin/VendorManagement/ManageCategories";
import TaxManagement from "pages/SuperAdmin/VendorManagement/TaxManagement";
import ManageSalesRep from "pages/SuperAdmin/VendorManagement/ManageSalesRep";
import ManageVendors from "pages/SuperAdmin/VendorManagement/ManageVendors";
import viewVendorDetails from "pages/SuperAdmin/VendorManagement/ManageVendors/components/VendorDetailTabs/ViewVendorDetails";
import VendorDetailTabs from "pages/SuperAdmin/VendorManagement/ManageVendors/components/VendorDetailTabs";
import VendorAccountSetup from "VendorManagement/pages/SetupAccount";
import ManageTopUp from "pages/SuperAdmin/VendorManagement/ManageTopUp";
import HelpDesk from "pages/SuperAdmin/VendorManagement/HelpDesk";
import AddCreditDetails from "VendorManagement/pages/AddBankDetails";
import AddBankDetails from "VendorManagement/pages/AddBankDetails/AddBankDetails";
import TicketDetails from "pages/SuperAdmin/VendorManagement/HelpDesk/TicketDetails";
import VendorEditProfile from "VendorManagement/pages/EditProfile/EditProfile";
import useHubspot from "hooks/useHubspot";
import PrivacyPolicyVendor from "pages/PrivacyPolicyVendor";
import TermsCondtionVendor from "pages/TermsCondtionVendor";
import ManageCommissions from "pages/SuperAdmin/VendorManagement/ManageCommissions";
import StaffListingTimesheet from "staff/pages/StaffListingTimesheet";
import TimesheetDetail from "staff/pages/StaffListingTimesheet/component/TimesheetDetail";
import TimesheetDateDetail from "staff/pages/StaffListingTimesheet/component/TimesheetDateDetail";
import StaffListingLeaves from "staff/pages/StaffListingLeaves";
import ApplyLeaves from "staff/pages/Leaves/component/ApplyLeaves";
import ManageSalesRepAdmin from "pages/SuperAdmin/VendorManagement/ManageSalesRep";
import FamilyMembers from "patient-scheduling/pages/FamilyMembers";
import AddEditMembers from "patient-scheduling/pages/FamilyMembers/components/AddEditMembers";
import ViewMemberDetail from "patient-scheduling/pages/FamilyMembers/components/ViewMemberDetail";
import PaymentSuccees from "VendorManagement/pages/PaymentSuccess";
import PaymentFailed from "pages/PaymentFailed";
import ViewFeatures from "pages/Subscription/ViewFeatures";
import AccountBasicSubscription from "pages/Subscription/AccountBasicSubscription";
import EditAccountBasicSubscription from "pages/Subscription/EditAccountBasicSubscription";
import ManageFeatures from "pages/Subscription/ManageFeatures";
import EditBasicSubscription from "pages/SuperAdmin/Account-owner/SubscriptionAndInvoices/EditBasicSubscription";
import UpdateSubscriptionModel from "components/UpdateSubscriptionModel";
import FindDoctors from "pages/FindDoctors";
import MoveToOfficeStaff from "pages/MoveToOfficeStaff";
import VendorSubscriptionPlans from "pages/SuperAdmin/VendorSubscriptionPlans";
import Appointments from "accountOwner/pages/Appointments";
import manageSchedule from "accountOwner/pages/Appointments/ManageSchedule";
import urbanDental from "accountOwner/pages/Appointments/ManageSchedule/UrbanDental";
import trackSchedule from "accountOwner/pages/Appointments/ManageSchedule/UrbanDental/TrackSchedule";
import RecallAppointment from "accountOwner/pages/Appointments/RecallTab/ReacllNewAppointment/RecallAppointment";
import selectNextRecall from "accountOwner/pages/Appointments/RecallTab/ReacllNewAppointment/NextRecallTime/NextRecallTime";
import selectDateTime from "accountOwner/pages/Appointments/RecallTab/SelectDateTime/SelectDateTime";
import AddNewAppointment from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment";
import SubmittedQuestionnaire from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/SubmittedQuestionnaire";
import PatientAppointmentType from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/PatientAppointmentDetails/PatientAppointmentType";
import PatientAppointmentReminder from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/PatientAppointmentDetails/PatientAppointmentReminder";
import EditRecall from "accountOwner/pages/Appointments/PastAppointmentTable/EditRecall";
import ReassignAppointment from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/PatientAppointmentDetails/ReassignAppointment";
import RescheduleAppointment from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/PatientAppointmentDetails/RescheduleAppointmnet";
import ReassignDateTime from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/PatientAppointmentDetails/ReassignAppointment/ReassignDateTime";
import BasicSubscription from "pages/SuperAdmin/VendorSubscriptionPlans/components/BasicSubscription";
import EditVendorSubscription from "pages/SuperAdmin/VendorSubscriptionPlans/components/BasicSubscription/EditVendorSubscription";
import EnterpriseSubscription from "pages/SuperAdmin/VendorSubscriptionPlans/components/EnterpriseSubscription";
import AddNewPlan from "pages/SuperAdmin/VendorSubscriptionPlans/components/EnterpriseSubscription/components/AddNewPlan";
import AddNewVendor from "pages/SuperAdmin/VendorSubscriptionPlans/components/EnterpriseSubscription/components/EnterpriseSubscriptionDetails/components/AddNewVendor";
import EnterPriseSubscriptionDetail from "pages/SuperAdmin/VendorSubscriptionPlans/components/EnterpriseSubscription/components/EnterpriseSubscriptionDetails/EnterPriseSubscriptionDetail";
import VendorSubscriptionDetail from "pages/SuperAdmin/VendorManagement/ManageVendors/components/VendorDetailTabs/VendorSubscriptionDetail";
import EditSubscriptionforVendors from "pages/SuperAdmin/VendorManagement/ManageVendors/components/VendorDetailTabs/EditSubscriptionforVendors";
import VendorTransactionHistory from "pages/SuperAdmin/VendorManagement/ManageVendors/components/VendorDetailTabs/VendorTransactionHistory";
import ManageVendorSubscription from "VendorManagement/pages/ManageVendorSubscription";
import ManageVendorCard from "VendorManagement/pages/ManageVendorSubscription/components/ManageVendorCard";
import ChangeSubscription from "VendorManagement/pages/ManageVendorSubscription/components/ChangeSubscription";
import VendorFreeTrial from "VendorManagement/VendorFreeTrial";
import EditVendorCards from "VendorManagement/pages/ManageVendorSubscription/components/EditVendorCards";
import CustomErorPage from "components/CustomErrorPage";
import * as Sentry from "@sentry/react";
import PMSMembers from "staff/pages/PMSMembers";
import OfficesListForPms from "pages/OfficesListForPms";
import CustomAppointmentConfirmationPage from "components/CustomAppointmentConfirmationPage";
import AccountPrefences from "pages/AccountPreferences";
import MessageTemplates from "pages/AccountPreferences/components/MessageTemplates";
import ManageMessageTemplates from "pages/AccountPreferences/components/ManageMessageTemplate";
import ViewMessageTemplates from "pages/AccountPreferences/components/ViewMessageTemplate";
import AppointmentConfirmationPageForNonMiraxis from "components/AppointmentConfirmationPageForNonMiraxis";
import TaskManagement from "accountOwner/pages/TaskManagement";
import TaskDetail from "accountOwner/pages/TaskManagement/TaskDetail";
import OwnerTaskDetails from "accountOwner/pages/TaskManagement/TaskDetail/owner";
import PatientDetails from "accountOwner/pages/TaskManagement/TaskDetail/PatientDetails/PatientDetails";
import AddNewNote from "accountOwner/pages/TaskManagement/AddNewNote/AddNewNote";
import TaskPerformance from "accountOwner/pages/TaskManagement/TaskPerformance/TaskPerformance";
import PerformanceDetail from "accountOwner/pages/TaskManagement/TaskPerformance/PerformanceDetail/PerformanceDetail";
import Notes from "accountOwner/pages/Notes";
import AddNote from "accountOwner/pages/Notes/component/AddNote";
import NoteDetails from "accountOwner/pages/Notes/component/NoteDetails";
import DiscussionNote from "accountOwner/pages/DiscussionNotes";
import DiscussionNoteDetails from "accountOwner/pages/DiscussionNotes/NoteDetails/index";
import Forms from "accountOwner/pages/Forms";
import Contracts from "accountOwner/pages/Forms/Contracts";
import EmploymentProof from "accountOwner/pages/Forms/EmployementProof";
import EmploymentProofForm from "accountOwner/pages/Forms/EmployementProof/EmploymentProofForm";
import PerformanceReview from "accountOwner/pages/PerformanceReview";
import AddNewPerformanceReview from "accountOwner/pages/PerformanceReview/AddNewPerformanceReview";
import ReviewForm from "accountOwner/pages/PerformanceReview/ReviewForm";
import PreviewForm from "accountOwner/pages/PerformanceReview/PreviewForm";
import EmploymentProofReview from "accountOwner/pages/Forms/EmployementProof/components/EmploymentProofReview";
import Notices from "accountOwner/pages/Notices";
import AddNotice from "accountOwner/pages/Notices/AddNotice/AddNotice";
import NoticeDetails from "accountOwner/pages/Notices/NoticeDetails/NoticeDetails";
import SeeTodaySchedule from "accountOwner/pages/Appointments/SeeTodaySchedule";
import SelectAppointmentType from "accountOwner/pages/Appointments/ManageSchedule/UrbanDental/CreateAppointment/SelectAppointmentType";
import SelectReminderPlan from "accountOwner/pages/Appointments/ManageSchedule/UrbanDental/CreateAppointment/SelectReminderPlan";
import SelectPatientAppointmentType from "accountOwner/pages/Appointments/PatientNewAppointment/SelectPatientAppointmentType";
import SelectPatientAppointmentReminderPlan from "accountOwner/pages/Appointments/PatientNewAppointment/SelectPatientAppointmentReminderPlan";
import RecallAppointmentType from "accountOwner/pages/Appointments/RecallTab/ReacllNewAppointment/RecallAppointmentType";
import RecallAppointmentReminderPlan from "accountOwner/pages/Appointments/RecallTab/ReacllNewAppointment/RecallAppointmentReminderPlan";
import SelectPastAppointmentReminder from "accountOwner/pages/Appointments/PastAppointmentTable/EditRecall/SelectPastAppointmentReminder";
import AppointmentDashboard from "pages/SuperAdmin/AppointmentDashboard/AppointmentDashboard";
import PatientMessageCenter from "accountOwner/pages/Appointments/PatientMessageCenter";
import PatientNewMessage from "accountOwner/pages/Appointments/PatientMessageCenter/PatientNewMessage/PatientNewMessage";
import ViewTemplate from "accountOwner/pages/Appointments/PatientMessageCenter/ViewTemplate/ViewTemplate";
import AppointmentRoutes from "accountOwner/pages/Appointments/AppointmentsContext";
import PatientsList from "accountOwner/pages/Appointments/Patients";
import PatientDetail from "accountOwner/pages/Appointments/Patients/PatientDetail";
import PatientNotes from "accountOwner/pages/Appointments/Patients/Notes/PatientNotes";
import AddPatientNote from "accountOwner/pages/Appointments/Patients/Notes/AddPatientNote";
import PatientNoteDetail from "accountOwner/pages/Appointments/Patients/Notes/PatientNoteDetail";
import PatientStatus from "accountOwner/pages/Appointments/Patients/PatientStatus";
import CovindForm from "accountOwner/pages/Appointments/AppointmentsTable/AddNewAppointment/CovindForm";
import DeleteEvents from "accountOwner/pages/DeleteEvent/DeleteEvents";
import TimeLinePreferences from "accountOwner/pages/OfficeOptions/TimeLinePreferences";
import RecallReminderEdit from "accountOwner/pages/Appointments/RecallTab/ReacllNewAppointment/NextRecallTime/RecallReminderEdit";
import NextRecallEdit from "accountOwner/pages/Appointments/RecallTab/ReacllNewAppointment/NextRecallTime/NextRecallEdit";
import ManagerDashboard from "accountOwner/pages/ManagerDashboard/ManagerDashboard";
import PatientConversation from "Messenger/pages/PatientConversation";
import AppointmentListTable from "Messenger/pages/PatientConversation/component/AppointmentListTable";
import AddUpdateTimesheet from "staff/pages/StaffListingTimesheet/component/AddUpdateTimesheet";
import EditTimesheet from "staff/pages/StaffListingTimesheet/component/EditTimesheet";
import TimesheetReport from "staff/pages/TimesheetReport";
import CallViewNew from "Messenger/calling/views/CallView/CallViewNew";
import RedirectionForPatientAndDoctor from "Messenger/pages/redirectionPageForPatientAndDoctor";
import EventHistoryLogs from "accountOwner/pages/EventDetails/components/EventHistoryLogs";
import { withTranslation } from "react-i18next";
import FiscalYear from "accountOwner/pages/FiscalYear/FiscalYear";
import CompanyBranding from "pages/AccountPreferences/components/CompanyBranding";
import TimesheetSubmissionPreferences from "accountOwner/pages/OfficeOptions/TimesheetSubmissionPreferences";
import LeavesHistoryLogs from "staff/pages/StaffListingLeaves/LeavesHistoryLogs";
import OfficePolicyManagement from "accountOwner/pages/OfficePolicyManagement";
import Contact from "pages/Contact";
import AboutUs from "pages/AboutUs";
import AISettings from "pages/SuperAdmin/AISettings";
import ManageSystemInstruction from "pages/SuperAdmin/AISettings/ManageSystemInstructions";
import ManageDocuments from "pages/SuperAdmin/AISettings/ManageDocument";
import ManagePrompts from "pages/SuperAdmin/AISettings/ManagePrompts";
import AddEditPrompt from "pages/SuperAdmin/AISettings/ManagePrompts/components/AddEditPrompt";
import ViewPromptDetail from "pages/SuperAdmin/AISettings/ManagePrompts/components/ViewPromptDetail";
import RatingResponses from "pages/SuperAdmin/AISettings/RatingResponses";
import ChatHistory from "pages/SuperAdmin/AISettings/ChatHistory";
import RatingResponseView from "pages/SuperAdmin/AISettings/RatingResponses/components/ResponseView";
import OfficeStaffInformation from "accountOwner/pages/OfficeStaffInformation";
import AccountOwnerProvider from "lib/Context/AccountOwner";
import ViewChatDetails from "pages/SuperAdmin/AISettings/ChatHistory/components/ViewChatDetails";
import ReportedResponses from "pages/SuperAdmin/AISettings/ReportedResponses";
import ViewReportedResponseDetails from "pages/SuperAdmin/AISettings/ReportedResponses/components/ViewReportedResponseDetails";
import ManageAiDocuments from "pages/AccountPreferences/components/ManageAiDocuments";
import ViewManageAiDocuments from "pages/AccountPreferences/components/ViewManageAiDocuments";
import PolicyAcknowledgementTemplate from "pages/AccountPreferences/components/PolicyAcknowledgementTemplate";
import GlobalOfficeStaffInformation from "accountOwner/pages/OfficeStaffInformation/GlobalOfficeStaffInformation";
import ErrorBoundary from "ErrorBoundary";
import StaffAttendance from "accountOwner/pages/StaffAttendance";
import CredentialsAndLicensing from "pages/CredentialsAndLicensing";
import CredentialsAndLicensingGlobalListing from "pages/CredentialsAndLicensingGlobalListing";
import AddNewPolicy from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/AddNewPolicy";
import CrdentialDetailPage from "../pages/CredentialsAndLicensingGlobalListing/CrdentialDetailPage";
import AddEditPolicyFolder from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/AddEditPolicyFolder";
import RenewAcknowledgement from "accountOwner/pages/OfficePolicyManagement/components/RenewAcknowledgement";
import PolicyDocumentListing from "accountOwner/pages/OfficePolicyManagement/components/PolicyDocumentListing";
import PolicyLogsListing from "accountOwner/pages/OfficePolicyManagement/components/PolicyLogsListing";
import ViewPolicy from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/ViewPolicy";
import OwnerPolicyViewEntry from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/OwnerPolicyViewEntry";
import OfficePolicyDetails from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/OfficePolicyDetails";
import LatestPolicyRedirect from "accountOwner/pages/OfficePolicyManagement/ManagePolicy/LatestPolicyRedirect";
import PolicyDetailsHistoryLogs from "../accountOwner/pages/OfficePolicyManagement/components/PolicyDetailsHistoryLogs";
import { useMsal } from "@azure/msal-react";
import { MFA_STORAGE_CHANGED_EVENT } from "utils/mfaStorage";
const history = createBrowserHistory();

/** `/` resolves only through {@link PrivateRoutes} role redirects; this is never rendered. */
const HomeRootPlaceholder = () => null;

const dashboardRoute = (isInterceptorInitialized, t) => (
  <App path="/" history={history} t={t}>
    <AllRoutes isInterceptorInitialized={isInterceptorInitialized} />
  </App>
);

function AllRoutes({ isInterceptorInitialized }) {
  if (!isInterceptorInitialized) {
    return null;
  }

  return (
    <Switch>
      {/*
        MFA lives under App's Route, not here. Without this, /authenticate hits * → /404
        when `children` (this Switch) mounts while the user is still on the MFA URL.
      */}
      <Route exact path="/authenticate" render={() => null} />
      <PrivateRoutes
        component={Contact}
        path={constants.routes.contact}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AboutUs}
        path={constants.routes.aboutMiraxis}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={Privacy}
        path={constants.routes.privacyPolicy}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={Terms}
        path={constants.routes.termsAndConditions}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* Vendor Module Pages */}
      <PrivateRoutes
        component={Dashboard}
        path={constants.routes.vendor.dashboard}
        roles={[constants.systemRoles.vendor]}
      />

      <PrivateRoutes
        component={ManageOrders}
        path={constants.routes.vendor.manageOrders}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ManageCatalogue}
        path={constants.routes.vendor.manageCatalogue}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ManageCustomers}
        path={constants.routes.vendor.manageCustomers}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={Promotion}
        path={constants.routes.vendor.promotion}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={PromoCodes}
        path={constants.routes.vendor.promoCodes}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={TopUp}
        path={constants.routes.vendor.topup}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ManageVendorSubscription}
        path={constants.routes.vendor.manageSubscription}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ChangeSubscription}
        path={constants.routes.vendor.changeSubscription}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ManageVendorCard}
        path={constants.routes.vendor.manageVendorCards}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={EditVendorCards}
        path={constants.routes.vendor.editVendorCards}
        roles={[constants.systemRoles.vendor]}
      />

      <PrivateRoutes
        component={SupportHelpdesk}
        path={constants.routes.vendor.supportHelpdesk}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ManageSaleRep}
        path={constants.routes.vendor.manageSalesRep}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={ManageInvoices}
        path={constants.routes.vendor.manageInvoices}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={PaymentSuccees}
        path={constants.routes.vendor.paymentSuccess}
        roles={[constants.systemRoles.vendor]}
      />

      <PrivateRoutes
        component={AddNewItem}
        path={constants.routes.vendor.addNewItem}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={CatalogueDetail}
        path={constants.routes.vendor.catalogueDetail}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={AddNewTicket}
        path={constants.routes.vendor.addNewTicket}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={VendorTicketDetail}
        path={constants.routes.vendor.ticketDetail}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={CustomerDetail}
        path={constants.routes.vendor.customerDetail}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={InviteCustomers}
        path={constants.routes.vendor.inviteCustomers}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={VendorProfile}
        path={constants.routes.vendor.vendorProfile}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={OrderDetail}
        path={constants.routes.vendor.orderDetail}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={AddNewPromoCode}
        path={constants.routes.vendor.addPromoCode}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={AddNewPromotion}
        path={constants.routes.vendor.addPromotion}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={PromotionDetail}
        path={constants.routes.vendor.promotionDetail}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={InviteNewSalesRep}
        path={constants.routes.vendor.inviteSalesRep}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={EditSalesRep}
        path={constants.routes.vendor.editSalesRep}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={SalesRepDetail}
        path={constants.routes.vendor.salesRepDetail}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={VendorAccountSetup}
        path={constants.routes.vendor.accountSetup}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={VendorEditProfile}
        path={constants.routes.vendor.editProfile}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={AddCreditDetails}
        path={constants.routes.vendor.cardSetup}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={AddBankDetails}
        path={constants.routes.vendor.bankSetup}
        roles={[constants.systemRoles.vendor]}
      />
      <PrivateRoutes
        component={VendorFreeTrial}
        path={constants.routes.vendor.vendorPurchaseSubscription}
        roles={[constants.systemRoles.vendor]}
      />

      {/* Account Owner Profile setup pages */}
      <PrivateRoutes
        component={Account}
        path={constants.routes.account}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={CallViewNew}
        path={constants.routes.callViewNew}
        roles={[
          constants.systemRoles.superAdmin,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={AddSubscription}
        path={constants.routes.addSubscription}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={CardDetails}
        path={constants.routes.setupCard}
        roles={[constants.systemRoles.accountOwner]}
      />

      <PrivateRoutes
        component={EditProfile}
        path={constants.routes.editProfile}
        roles={[
          constants.systemRoles.superAdmin,
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={Profile}
        path={constants.routes.accountOwner.profile}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={Offices}
        path={constants.routes.accountOwner.offices}
        roles={[constants.systemRoles.accountOwner]}
      />

      <PrivateRoutes
        component={SelectOffice}
        path={constants.routes.accountOwner.selectOffice}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={AddOffice}
        path={[
          constants.routes.accountOwner.addOffice,
          constants.routes.accountOwner.editOffice,
        ]}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={AddStaff}
        path={[
          constants.routes.accountOwner.addStaff,
          constants.routes.accountOwner.editStaff,
          constants.routes.globalStaffAdd,
          constants.routes.accountOwner.updateMultipleStaffForMultipleOffices,
          constants.routes.accountOwner.updateMultipleStaffForSingleOffice,
          constants.routes.accountOwner.updateStaffForMultipleOffices,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={Staff}
        path={[
          constants.routes.staff.adminStaffListing,
          constants.routes.globalStaffList,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={StaffDetail}
        path={[
          constants.routes.staff.staffDetail,
          constants.routes.staff.globaleStaffDetail,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={HourlyRateHistory}
        path={constants.routes.staff.hourlyRate}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={MobileApp}
        path="/app"
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        exact
        component={StaffList}
        path="/office/:officeId/staff"
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* Contract pages */}
      <PrivateRoutes
        component={Forms}
        path={constants.routes.accountOwner.forms}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={Forms}
        path={constants.routes.accountOwner.myForms}
        roles={[constants.systemRoles.staff]}
      />

      <PrivateRoutes
        component={EmploymentProof}
        path={constants.routes.accountOwner.employementProof}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={EmploymentProof}
        path={constants.routes.accountOwner.myEmployementProof}
        roles={[constants.systemRoles.staff]}
      />

      <PrivateRoutes
        component={PerformanceReview}
        path={constants.routes.accountOwner.myPerformanceReview}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        component={PerformanceReview}
        path={constants.routes.accountOwner.performanceReview}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={AddNewPerformanceReview}
        path={constants.routes.accountOwner.addNewPerformanceReview}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={ReviewForm}
        path={constants.routes.accountOwner.performanceReviewForm}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PreviewForm}
        path={constants.routes.accountOwner.previewReviewForm}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={EmploymentProofForm}
        path={constants.routes.accountOwner.employmentProofForm}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={EmploymentProofReview}
        path={constants.routes.accountOwner.employmentProofFormReview}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={Contracts}
        path={constants.routes.accountOwner.contracts}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={StaffContracts}
        path={constants.routes.accountOwner.staffContracts}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={NewEmploymentContract}
        path={[
          constants.routes.accountOwner.newContract,
          constants.routes.accountOwner.editContract,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={OwnerViewContract}
        path={constants.routes.accountOwner.viewContract}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={AccountOwnerRoutes}
        path={[
          "/manage-owner",
          "/account-owner/:accountOwnerId",
          "/account-owner/:accountOwnerId/transaction-history",
          "/account-owner/:accountOwnerId/subscription-and-invoices",
        ]}
        roles={[
          constants.systemRoles.superAdmin,
          constants.systemRoles.accountOwner,
        ]}
      />

      <PrivateRoutes
        component={AppointmentListTable}
        path={constants.routes.patientListOfAppointment}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={PersonnelRoutes}
        path={["/manage-personnel", "/personnel/:personnelId"]}
        roles={[constants.systemRoles.superAdmin]}
      />

      {/*  Appointment Request List for SuperAdmin*/}
      <PrivateRoutes
        exact
        component={AppointmentRequests}
        path={constants.routes.superAdmin.appointmentRequestList}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={AppointmentRequestDetail}
        path={constants.routes.superAdmin.appointmentRequestDetail}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={Feedback}
        path={constants.routes.superAdmin.feedback}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={FeedBackView}
        path={constants.routes.superAdmin.feedbackView}
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* Chat Messanger for Account Owner, Staff, and Vendor */}
      <PrivateRoutes
        component={TeamConversation}
        path={constants.routes.chatModule}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
          constants.systemRoles.vendor,
        ]}
      />

      <PrivateRoutes
        component={PatientList}
        path={constants.routes.superAdmin.patientList}
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* Patient Live Chat for Account Owner and Staff */}
      <PrivateRoutes
        component={PatientConversation}
        path={constants.routes.patientChatModule}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={RedirectionForPatientAndDoctor}
        path={constants.routes.conversationRedirection}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
          constants.systemRoles.patient,
        ]}
      />
      {/* Owner or Doctor Live Chat for patient */}
      <PrivateRoutes
        component={PatientConversation}
        path={constants.routes.patientWithOwnerOrDoctorChatModule}
        roles={[constants.systemRoles.patient]}
      />

      {/* Mir notes web account owner */}

      <PrivateRoutes
        component={Notes}
        path={constants.routes.notes}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={AddNote}
        path={constants.routes.addNote}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={NoteDetails}
        path={constants.routes.noteDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={NoteDetails}
        path={constants.routes.transferredNoteDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Task Management */}

      <PrivateRoutes
        exact
        component={TaskManagement}
        path={constants.routes.taskManagements.taskManagement}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        exact
        component={TaskDetail}
        path={constants.routes.taskManagements.taskDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        exact
        component={OwnerTaskDetails}
        path={constants.routes.taskManagements.ownerTaskDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientDetails}
        path={constants.routes.taskManagements.patientDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddNewNote}
        path={constants.routes.taskManagements.taskManagementAddNote}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddNewNote}
        path={constants.routes.taskManagements.taskManagementEditNote}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={TaskPerformance}
        path={constants.routes.taskManagements.taskPerformance}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={PerformanceDetail}
        path={constants.routes.taskManagements.performanceDetail}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Office Policy Management */}

      <PrivateRoutes
        exact
        component={OfficePolicyManagement}
        path={constants.routes.officePolicyManagements.officePolicyManagement}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={LatestPolicyRedirect}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementLatestPolicy
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={RenewAcknowledgement}
        path={constants.routes.officePolicyManagements.renewAcknowledgement}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={PolicyDocumentListing}
        path={constants.routes.officePolicyManagements.policyDocumentListing}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={PolicyLogsListing}
        path={constants.routes.officePolicyManagements.policyLogsListing}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={PolicyDetailsHistoryLogs}
        path={constants.routes.officePolicyManagements.policyDetailsHistoryLogs}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddEditPolicyFolder}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementAddPolicyFolder
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddNewPolicy}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementAddPolicy
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddNewPolicy}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementEditPolicy
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={OwnerPolicyViewEntry}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementOwnerDetailView
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={ViewPolicy}
        path={
          constants.routes.officePolicyManagements
            .ownerOfficePolicyManagementDetails
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={OfficePolicyDetails}
        path={
          constants.routes.officePolicyManagements.officePolicyManagementDetails
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddEditPolicyFolder}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementEditPolicyFolder
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={AddEditPolicyFolder}
        path={
          constants.routes.officePolicyManagements
            .officePolicyManagementEditPolicyFolder
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Credentials and Licensing */}

      <PrivateRoutes
        exact
        component={CredentialsAndLicensing}
        path={constants.routes.credentialsAndLicensing.credentialsAndLicensing}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        exact
        component={CredentialsAndLicensingGlobalListing}
        path={
          constants.routes.credentialsAndLicensing.credentialsAndLicensingGlobal
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={CrdentialDetailPage}
        path={
          constants.routes.credentialsAndLicensing
            .credentialsAndLicensingGlobalDetail
        }
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={NoteDetails}
        path={constants.routes.transferredNoteDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Staff Attendance */}

      <PrivateRoutes
        exact
        component={StaffAttendance}
        path={constants.routes.staffAttendance.staffAttendance}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Notices */}

      <PrivateRoutes
        component={Notices}
        path={constants.routes.accountOwner.notices}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={Notices}
        path={constants.routes.accountOwner.myNotices}
        roles={[constants.systemRoles.staff]}
      />

      <PrivateRoutes
        component={AddNotice}
        path={constants.routes.accountOwner.addNotice}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={NoticeDetails}
        path={constants.routes.accountOwner.noticeDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={NoticeDetails}
        path={constants.routes.accountOwner.myNoticeDetails}
        roles={[constants.systemRoles.staff]}
      />

      <PrivateRoutes
        component={AppointmentRoutes}
        path={[
          constants.routes.appointment.feedbackConfirmation,
          constants.routes.waitingList,
          constants.routes.waitingAppoimentDetail,
          constants.routes.appointment.createAppointment,
          constants.routes.appointment.appointmentType,
          constants.routes.appointment.appointmentReminder,
          constants.routes.appointment.addAppointmentReminderPlan,
          constants.routes.appointment.createMessageTemplates,
          constants.routes.appointment.acceptPatientAppointment,
          constants.routes.appointment.patientNewAppointment,
          constants.routes.appointment.officeSelection,
          constants.routes.appointment.createRecallPatientAppointment,
          constants.routes.appointment.linkToNextRecall,
          constants.routes.appointment.recall,
          constants.routes.appointment.reminder,
          constants.routes.appointment.recallReminderEdit,
          constants.routes.appointment.globalReminder,
          constants.routes.appointment.patientAppointmentReminder,
          constants.routes.appointment.patientAddAppointmentReminderPlan,
          constants.routes.appointment.createMessageHistoryTemplates,
          constants.routes.appointment.AccountGlobalReminder,
          constants.routes.appointment.AccountGlobalOfficeReminder,
          constants.routes.appointment.doctorSelection,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientsList}
        path={[constants.routes.appointment.patients]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientDetail}
        path={[constants.routes.appointment.patientDetail]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientNotes}
        path={[constants.routes.appointment.patientNotes]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientStatus}
        path={[constants.routes.appointment.patientStatus]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={AddPatientNote}
        path={[constants.routes.appointment.addPatientNotes]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientNoteDetail}
        path={[constants.routes.appointment.patientNoteDetail]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={PatientMessageCenter}
        path={constants.routes.appointment.patientMessageCenter}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={PatientNewMessage}
        path={constants.routes.appointment.patientNewMessage}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={ViewTemplate}
        path={constants.routes.appointment.patientViewTemplate}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* AI Assistant */}
      <PrivateRoutes
        component={AISettings}
        path={constants.routes.aiAssistant.aiSetting}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageSystemInstruction}
        path={constants.routes.aiAssistant.manageSystemInstruction}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageDocuments}
        path={constants.routes.aiAssistant.manageDocuments}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManagePrompts}
        path={constants.routes.aiAssistant.managePrompts}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddEditPrompt}
        path={constants.routes.aiAssistant.addPrompt}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddEditPrompt}
        path={constants.routes.aiAssistant.editPrompt}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ViewPromptDetail}
        path={constants.routes.aiAssistant.viewPrompt}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={RatingResponses}
        path={constants.routes.aiAssistant.ratingResponses}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={RatingResponseView}
        path={constants.routes.aiAssistant.ratingResponseView}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ChatHistory}
        path={constants.routes.aiAssistant.chatHistory}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ViewChatDetails}
        path={constants.routes.aiAssistant.chatHistoryView}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ReportedResponses}
        path={constants.routes.aiAssistant.reportedResponse}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ViewReportedResponseDetails}
        path={constants.routes.aiAssistant.reportedResponseView}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageAiDocuments}
        path={constants.routes.aiAssistant.manageAiDocuments}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={ViewManageAiDocuments}
        path={constants.routes.aiAssistant.viewManageAiDocuments}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
          constants.systemRoles.superAdmin,
        ]}
      />
      {/* App Version */}
      <PrivateRoutes
        exact
        component={AppVersionList}
        path={constants.routes.appVersionList}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={AppVersionForm}
        path={constants.routes.appVersionForm}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={AppVersionForm}
        path={constants.routes.appVersionForm + "/:appVersionId"}
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* Speciality */}
      <PrivateRoutes
        exact
        component={SpecialtyList}
        path={constants.routes.specialtyList}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={SpecialtyForm}
        path={constants.routes.specialtyForm}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={SpecialtyForm}
        path={constants.routes.specialtyForm + "/:specialtyId"}
        roles={[constants.systemRoles.superAdmin]}
      />

      <PrivateRoutes
        component={StaffRoles}
        path={constants.routes.accountOwner.staffRoles}
        roles={[
          constants.systemRoles.superAdmin,
          constants.systemRoles.accountOwner,
        ]}
      />

      {/* Patient Scheduling */}
      <Route exact component={Doctors} path={constants.routes.doctors} />
      <Route
        exact
        component={SearchDoctorBySpecialty}
        path={constants.routes.searchDoctorBySpecialty}
      />
      <Route exact component={DoctorDetail} path={constants.routes.doctor} />
      <Route
        exact
        component={WaitingListForm}
        path={constants.routes.watingListRequest}
      />
      <Route
        exact
        component={SetLocation}
        path={constants.routes.setLocation}
      />
      <Route
        exact
        component={DoctorOffices}
        path={constants.routes.doctorOffices}
      />
      <Route
        exact
        component={DoctorReviewsByOffice}
        path={constants.routes.doctorReviews}
      />
      <Route component={Privacy} path={constants.routes.privacyPolicy} />
      <Route component={Terms} path={constants.routes.termsAndConditions} />
      <Route
        component={CustomAppointmentConfirmationPage}
        path="/appointment-confirmation/:appointment_id"
      />
      <Route
        component={AppointmentConfirmationPageForNonMiraxis}
        path={constants.routes.appointementConfirmationForNonMiraxis}
      />
      <Route
        component={PrivacyPolicyPatient}
        path={constants.routes.privacyPolicyPatient}
      />
      <Route
        component={TermsCondtionPatient}
        path={constants.routes.termsAndConditionsPatient}
      />
      <Route
        component={PrivacyPolicyVendor}
        path={constants.routes.privacyPolicyVendor}
      />
      <Route
        component={TermsCondtionVendor}
        path={constants.routes.termsAndConditionsVendor}
      />
      <Route
        component={RequestAnAppointment}
        path={constants.routes.requestAnAppointment}
      />
      <Route
        component={QuestionnaireForm}
        path={constants.routes.questionnaireForm}
      />
      <Route component={FamilyMembers} path={constants.routes.familyMembers} />
      <Route component={AddEditMembers} path={constants.routes.addNewMember} />
      <Route component={AddEditMembers} path={constants.routes.editMember} />
      <Route component={ViewMemberDetail} path={constants.routes.viewMember} />

      {/* Common  */}
      <Route
        exact
        component={DownloadIcs}
        path={constants.routes.downloadIcs}
      />

      <PrivateRoutes
        component={ManageContent}
        path="/manage-content"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageSalesRepAdmin}
        path={constants.routes.superAdmin.manageSalesRepAdmin}
        roles={[constants.systemRoles.superAdmin]}
      />

      <PrivateRoutes
        component={ChangePassword}
        path="/change-password"
        roles={[
          constants.systemRoles.superAdmin,
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SubscriptionMangement}
        path="/subscription-management"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EnterPrisePlans}
        path="/enterprise-plans"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddEnterPrisePlan}
        path={["/add-enterprise-plan", "/edit-enterprise-plan"]}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={PlanDetail}
        path={["/single-office", "/multiple-office"]}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AccountBasicSubscription}
        path={constants.routes.superAdmin.accountBasicSubscription}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EditAccountBasicSubscription}
        path={constants.routes.superAdmin.editAccountBasicSubscription}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageFeatures}
        path={constants.routes.superAdmin.manageFeatures}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EnterPriseOwners}
        path="/owners/:id"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddOwner}
        path={["/add-owner/:id", "/edit-owner/:id"]}
        roles={[constants.systemRoles.superAdmin]}
      />

      <PrivateRoutes
        component={EditPlans}
        path="/edit-plan/:id"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AccountManageSubscription}
        path={constants.routes.accountOwner.managePlan}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={SubscriptionPlans}
        path="/change-plan"
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={MangeHolidays}
        path={constants.routes.accountOwner.manageHolidays}
        roles={[
          constants.systemRoles.superAdmin,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={OfficesListForPms}
        path={constants.routes.accountOwner.officesList}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={AccountPrefences}
        path={constants.routes.accountPreferences}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={MessageTemplates}
        path={constants.routes.accountPreference.messageTemplates}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={PolicyAcknowledgementTemplate}
        path={constants.routes.accountPreference.policyAcknowledgementTemplate}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={ManageMessageTemplates}
        path={[
          constants.routes.accountPreference.addMessageTemplates,
          constants.routes.accountPreference.editMessageTemplates,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* <PrivateRoutes
         component={ManageMessageTemplates}
         path={[constants.routes.appointment.createMessageHistoryTemplates]}
         roles={[constants.systemRoles.accountOwner, constants.systemRoles.staff]}
       /> */}

      <PrivateRoutes
        component={ViewMessageTemplates}
        path={constants.routes.accountPreference.viewMessageTemplates}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={CompanyBranding}
        path={constants.routes.accountPreference.companyBranding}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={DemoRequest}
        path="/demo-request"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={BroadcastMessages}
        path={constants.routes.superAdmin.broadCastMessages}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddBroadcastMessage}
        path={constants.routes.superAdmin.createBroadCastMessage}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={BroadcastMessageDetail}
        path="/broadcast-message-detail/:id"
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* Reviews */}
      <PrivateRoutes
        exact
        component={Reviews}
        path={constants.routes.superAdmin.reviews}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={DoctorReviews}
        path={constants.routes.superAdmin.doctorReviews}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        exact
        component={PatientReviews}
        path={constants.routes.superAdmin.patientReviews}
        roles={[constants.systemRoles.superAdmin]}
      />

      <PrivateRoutes
        component={ManageTestimonial}
        path="/manage-testimonial"
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddTestimonial}
        path={["/add-testimonial", "/edit-testimonial"]}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ChangeCard}
        path="/change-card-detail/:id"
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.vendor,
        ]}
      />
      <PrivateRoutes
        component={ManageCards}
        path={constants.routes.accountOwner.manageCards}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        component={ViewFeatures}
        path={constants.routes.accountOwner.viewFeatures}
        roles={[constants.systemRoles.accountOwner]}
      />

      {/* Office related  */}
      <PrivateRoutes
        exact
        component={OfficeOptions}
        path={constants.routes.accountOwner.officeOptions}
        roles={[constants.systemRoles.accountOwner]}
      />
      <PrivateRoutes
        exact
        component={Preferences}
        path={constants.routes.accountOwner.preferences}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={TimesheetSubmissionPreferences}
        path={constants.routes.accountOwner.submissionPreferences}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={FiscalYear}
        path={constants.routes.accountOwner.fiscalYear}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={TimeLinePreferences}
        path={constants.routes.accountOwner.timelinePreferences}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={OfficeStaffInformation}
        path={constants.routes.accountOwner.officeStaffInformation}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={GlobalOfficeStaffInformation}
        path={constants.routes.accountOwner.globalOfficeStaffInformation}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={DiscussionNote}
        path={constants.routes.accountOwner.discussionNotes}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={DiscussionNoteDetails}
        path={constants.routes.accountOwner.discussionNotesDetail}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        exact
        component={DefineGeoFence}
        path={constants.routes.accountOwner.geoFence}
        roles={[constants.systemRoles.accountOwner]}
      />

      <PrivateRoutes
        component={StaffOffices}
        path={constants.routes.staff.offices}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        exact
        component={StaffOfficeOptions}
        path={constants.routes.staff.officeOptions}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        exact
        component={OfficeContracts}
        path={constants.routes.staff.officeContracts}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        exact
        component={ViewContract}
        path={constants.routes.staff.viewContract}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        exact
        component={AccountAdmin}
        path={constants.routes.staff.officeAdmin}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        component={Timesheet}
        path={constants.routes.staff.timesheet}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={AddUpdateTimesheet}
        path={constants.routes.accountOwner.updateTimesheetForStaff}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EditTimesheet}
        path={constants.routes.accountOwner.editTimesheetForStaff}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={StaffListingTimesheet}
        path={constants.routes.staff.staffListingTimesheet}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={TimesheetReport}
        path={constants.routes.accountOwner.timesheetReport}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={TimesheetDateDetail}
        path={constants.routes.staff.timesheetDateDetail}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={TimesheetDetail}
        path={constants.routes.staff.timesheetDetail}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={TimesheetView}
        path={constants.routes.staff.timesheetSummary}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={TimesheetViewDetails}
        path={constants.routes.staff.timesheetViewDetail}
        roles={[constants.systemRoles.staff]}
      />
      <PrivateRoutes
        component={StaffListingLeaves}
        path={constants.routes.staff.leaves}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />

      <PrivateRoutes
        component={LeavesHistoryLogs}
        path={constants.routes.staff.leavesHistoryLogs}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={ApplyLeaves}
        path={[
          constants.routes.staff.applyLeaves,
          constants.routes.staff.editLeaves,
        ]}
        roles={[
          constants.systemRoles.staff,
          constants.systemRoles.accountOwner,
        ]}
      />
      <PrivateRoutes
        component={PMSMembers}
        path={constants.routes.pmsMembers}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Scheduler related  */}
      <PrivateRoutes
        component={Scheduler}
        path={constants.routes.scheduler.calendar}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddEvent}
        path={constants.routes.scheduler.addEvent}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventDetails}
        path={constants.routes.scheduler.eventDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddBusySlots}
        path={constants.routes.scheduler.addBusySlot}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddBusySlots}
        path={constants.routes.scheduler.editBusySlot}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventDetailsOnly}
        path={constants.routes.scheduler.eventDetailsOnly}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* EditBusySlot */}
      <PrivateRoutes
        component={BusySlotsDetail}
        path={constants.routes.scheduler.busySlotDetail}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventRequestDetails}
        path={constants.routes.scheduler.eventRequestDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventWorkingDetails}
        path={constants.routes.scheduler.EventWorkingDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EditEvent}
        path={constants.routes.scheduler.editEvent}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EditEvent}
        path={constants.routes.scheduler.duplicateEvent}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={DeleteEvents}
        path={[
          constants.routes.scheduler.deleteEvent,
          constants.routes.scheduler.deleteBusySlot,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventHistoryLogs}
        path={[
          constants.routes.scheduler.eventHistoryLogs,
          constants.routes.scheduler.busySlotHistoryLogs,
        ]}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      {/* Help and Feedback Modules */}
      <Route exact component={HelpPage} path={constants.routes.help} />
      <Route exact component={Faq} path={constants.routes.faq} />
      <Route exact component={OnlineHelp} path={constants.routes.onlineHelp} />

      <PrivateRoutes
        exact
        component={FeedbackPage}
        path={constants.routes.feedback}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
          constants.systemRoles.patient,
        ]}
      />

      <PrivateRoutes
        component={Notification}
        path={constants.routes.notification.notificationDetail}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SupportHelp}
        path={constants.routes.superAdmin.SupportAndHelp}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={TicketDetail}
        path={constants.routes.superAdmin.supportTicketDetail}
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* {Subscription module} */}
      <PrivateRoutes
        component={EditSubscription}
        path={constants.routes.superAdmin.editSubscription}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EditBasicSubscription}
        path={constants.routes.superAdmin.editBasicSubscription}
        roles={[constants.systemRoles.superAdmin]}
      />

      {/* superAdmin vendor section */}
      <PrivateRoutes
        component={HelpDesk}
        path={constants.routes.superAdmin.helpDesk}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageCategories}
        path={constants.routes.superAdmin.categories}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={TaxManagement}
        path={constants.routes.superAdmin.tax}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageSalesRep}
        path={constants.routes.superAdmin.sales}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageVendors}
        path={constants.routes.superAdmin.manageVendors}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={VendorSubscriptionPlans}
        path={constants.routes.superAdmin.vendorSubscriptionPlans}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={VendorDetailTabs}
        path={constants.routes.superAdmin.VendorDetails}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={viewVendorDetails}
        path={constants.routes.superAdmin.VendorProfile}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageTopUp}
        path={constants.routes.superAdmin.TopUpPromotions}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={TicketDetails}
        path={constants.routes.superAdmin.ticketDetails}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={ManageCommissions}
        path={constants.routes.superAdmin.manageCommissions}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={PaymentFailed}
        path={constants.routes.paymentfailed}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.vendor,
        ]}
      />
      <PrivateRoutes
        component={FindDoctors}
        path={constants.routes.findDoctors}
        roles={[constants.systemRoles.patient]}
      />
      <PrivateRoutes
        component={MoveToOfficeStaff}
        path={constants.routes.officeStaffs}
        roles={[constants.systemRoles.staff]}
      />
      {/* Appointments related */}

      <PrivateRoutes
        component={Appointments}
        path={constants.routes.appointment.appointmentScreen}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={manageSchedule}
        path={constants.routes.appointment.manageSchedule}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={urbanDental}
        path={constants.routes.appointment.officeSelection}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={trackSchedule}
        path={constants.routes.appointment.trackSchedule}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={RecallAppointment}
        path={constants.routes.appointment.recallAppointment}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={selectNextRecall}
        path={constants.routes.appointment.selectNextRecall}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={selectDateTime}
        path={constants.routes.appointment.selectDateTime}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddNewAppointment}
        path={constants.routes.appointment.patientAppointmentDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SubmittedQuestionnaire}
        path={constants.routes.appointment.submittedQuestionnaire}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={CovindForm}
        path={constants.routes.appointment.covingQuestionnaire}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* <PrivateRoutes component={PatientAppointmentDetails} path={constants.routes.appointment.acceptPatientAppointment} roles={[constants.systemRoles.accountOwner, constants.systemRoles.staff]} /> */}
      <PrivateRoutes
        component={PatientAppointmentType}
        path={constants.routes.appointment.patientAppointmentType}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={PatientAppointmentReminder}
        path={constants.routes.appointment.patientReminderPlan}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* <PrivateRoutes component={FeedbackConfirmation} path={constants.routes.appointment.feedbackConfirmation} roles={[constants.systemRoles.accountOwner, constants.systemRoles.staff]} /> */}
      <PrivateRoutes
        component={EditRecall}
        path={constants.routes.appointment.editRecall}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={ReassignAppointment}
        path={constants.routes.appointment.reassignAppointment}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={RescheduleAppointment}
        path={constants.routes.appointment.rescheduleAppointment}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={ReassignDateTime}
        path={constants.routes.appointment.reassignDateTime}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SeeTodaySchedule}
        path={constants.routes.appointment.seeTodaySchedule}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SelectAppointmentType}
        path={constants.routes.appointment.selectAppointmentType}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SelectReminderPlan}
        path={constants.routes.appointment.selectReminderPlan}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* <PrivateRoutes component={PatientNewAppointment} path={constants.routes.appointment.patientNewAppointment} roles={[constants.systemRoles.accountOwner, constants.systemRoles.staff]} /> */}
      <PrivateRoutes
        component={SelectPatientAppointmentType}
        path={constants.routes.appointment.selectPatientAppointmentType}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={SelectPatientAppointmentReminderPlan}
        path={constants.routes.appointment.selectPatientAppointmentReminderPlan}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* <PrivateRoutes component={NextRecallTime} path={constants.routes.appointment.recall} roles={[constants.systemRoles.accountOwner, constants.systemRoles.staff]} /> */}
      <PrivateRoutes
        component={RecallAppointmentType}
        path={constants.routes.appointment.recallPatientAppointmentType}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={RecallAppointmentReminderPlan}
        path={constants.routes.appointment.recallPatientReminderPlan}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* <PrivateRoutes component={RecallAppointment} path={constants.routes.appointment.createRecallPatientAppointment} roles={[constants.systemRoles.accountOwner, constants.systemRoles.staff]} /> */}
      <PrivateRoutes
        component={SelectPastAppointmentReminder}
        path={constants.routes.appointment.pastPatientReminderPlan}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={RecallReminderEdit}
        path={constants.routes.appointment.recallReminderEdit}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={NextRecallEdit}
        path={constants.routes.appointment.nextEditRecall}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      {/* <PrivateRoutes component={RecallReminderPlan} path={constants.routes.appointment.recallReminderPlan} roles={[constants.systemRoles.accountOwner]}/>  */}

      {/* Scheduler related  */}

      <PrivateRoutes
        component={Scheduler}
        path={constants.routes.scheduler.calendar}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddEvent}
        path={constants.routes.scheduler.addEvent}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventDetails}
        path={constants.routes.scheduler.eventDetails}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddBusySlots}
        path={constants.routes.scheduler.addBusySlot}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={AddBusySlots}
        path={constants.routes.scheduler.duplicateBusySlot}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EditBusySlot}
        path={constants.routes.scheduler.editBusySlot}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />
      <PrivateRoutes
        component={EventDetailsOnly}
        path={constants.routes.scheduler.eventDetailsOnly}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        component={BasicSubscription}
        path={constants.routes.superAdmin.vendorSubscriptionView}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EnterpriseSubscription}
        path={constants.routes.superAdmin.enterpriseSubscription}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EditVendorSubscription}
        path={constants.routes.superAdmin.editVendorSubscription}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddNewPlan}
        path={[
          constants.routes.superAdmin.addNewPlan,
          constants.routes.superAdmin.editEnterPricePlan,
        ]}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EnterPriseSubscriptionDetail}
        path={constants.routes.superAdmin.enterpriseSubscriptionDetails}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AddNewVendor}
        path={[
          constants.routes.superAdmin.addNewVendor,
          constants.routes.superAdmin.editAssignedVendor,
        ]}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={VendorSubscriptionDetail}
        path={constants.routes.superAdmin.vendorSubscriptionDetails}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={EditSubscriptionforVendors}
        path={constants.routes.superAdmin.editSubscriptionForVendors}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={VendorTransactionHistory}
        path={constants.routes.superAdmin.vendorTransactionHistory}
        roles={[constants.systemRoles.superAdmin]}
      />
      <PrivateRoutes
        component={AppointmentDashboard}
        path={constants.routes.superAdmin.appointmentDashboard}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.superAdmin,
          constants.systemRoles.staff,
        ]}
      />

      {/* Dashboard */}

      <PrivateRoutes
        component={ManagerDashboard}
        path={constants.routes.dashboard.managerDashboard}
        roles={[
          constants.systemRoles.accountOwner,
          constants.systemRoles.superAdmin,
          constants.systemRoles.staff,
        ]}
      />

      <PrivateRoutes
        exact
        path="/"
        component={HomeRootPlaceholder}
        roles={[]}
      />
      <Route component={NotFound} path="/404" />
      <Route component={CustomErorPage} path="/error" />
      <Redirect from="*" to="/404" />
    </Switch>
  );
}
export const Store = createContext();
const Routes = ({ t }) => {
  const { instance } = useMsal();
  const [isBack, setIsBack] = useState("");
  const [isSubscriptionModel, setIsSubscriptionModel] = useState(false);
  const [isModelOpenForNotification, setIsModelOpenForNotification] =
    useState(false);

  const [isInterceptorInitialized, setIsInterceptorInitialized] =
    useState(false);
  const responseInterceptorRef = useRef(null);
  useHubspot();
  // useLayoutEffect: response interceptor + MFA gate. Bearer is global (index.js).
  // MFA is written from hooks under App; Routes does not re-render on that, so we
  // listen for MFA_STORAGE_CHANGED_EVENT from utils/mfaStorage.
  useLayoutEffect(() => {
    const syncInterceptorFromMfaStorage = () => {
      const isMfaValidate = localStorage.getItem("mfa-validate");

      if (Helper.isLoggedIn() && isMfaValidate) {
        axios.defaults.headers.post["Content-Type"] = "application/json";
        if (responseInterceptorRef.current == null) {
          responseInterceptorRef.current = axios.interceptors.response.use(
            (response) => {
              return response;
            },
            async (error) => {
              if (error.response) {
                if (401 === error.response.status) {
                  const cfg = error.config;
                  if (cfg && !cfg.__mxhhRetriedAfter401) {
                    try {
                      const newToken = await refreshMsalIdTokenCoalesced();
                      cfg.__mxhhRetriedAfter401 = true;
                      const h = cfg.headers;
                      if (h && typeof h.set === "function") {
                        h.set("Authorization", `Bearer ${newToken}`);
                      } else {
                        cfg.headers = {
                          ...h,
                          Authorization: `Bearer ${newToken}`,
                        };
                      }
                      return axios(cfg);
                    } catch (refreshErr) {
                      console.warn(
                        "401: silent MSAL token refresh failed:",
                        refreshErr,
                      );
                    }
                  }
                  // Same as App: do not `replace("/")` while authenticated (main Switch sends `/` → offices).
                  finalizeAppLogoutRedirect(instance);
                }
                // Do not navigate to /error for API failures: many run in parallel after MFA;
                // 403/5xx on one call is not a fatal app state (was causing full-page flash).
                if (error.response.status >= 400) {
                  Sentry.captureException(error.response);
                }
              }
              return Promise.reject(error);
            },
          );
        }
        setIsInterceptorInitialized((prev) => (prev ? prev : true));
      } else {
        setIsInterceptorInitialized((prev) => (prev ? false : prev));
      }
    };

    syncInterceptorFromMfaStorage();
    window.addEventListener(
      MFA_STORAGE_CHANGED_EVENT,
      syncInterceptorFromMfaStorage,
    );
    return () => {
      window.removeEventListener(
        MFA_STORAGE_CHANGED_EVENT,
        syncInterceptorFromMfaStorage,
      );
    };
  }, [instance]);

  return (
    <Store.Provider
      value={{
        isBack,
        setIsBack,
        isSubscriptionModel,
        setIsSubscriptionModel,
        isModelOpenForNotification,
        setIsModelOpenForNotification,
      }}
    >
      <ErrorBoundary>
        <AccountOwnerProvider>
          <UpdateSubscriptionModel />
          <Route render={() => dashboardRoute(isInterceptorInitialized, t)} />
        </AccountOwnerProvider>
      </ErrorBoundary>
    </Store.Provider>
  );
};
export default withTranslation()(Routes);
